import * as React from "react";
import { resolveDiagramSvgHeight } from "../shared/diagramSvgDimensions";


import { CardiometabolicFatMetabolismDiagramContent } from "./CardiometabolicFatMetabolismDiagram";
import { CardiometabolicFatMetabolismKeyContent } from "./CardiometabolicFatMetabolismKey";

const SvgCardiometabolicFatMetabolismDiagramKey = ({
  geneColors = {},
  expectedSnps = {},
  showKey = true,
  keyControlsId = "diagram-key",
  onGeneClick,
  width: widthProp,
  height: heightProp,
  ...props
}) => {
  const diagramOnly = !showKey;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      {...props}
      width={widthProp ?? 1024}
      height={resolveDiagramSvgHeight(heightProp, diagramOnly, 1370, 1614)}
      viewBox={diagramOnly ? "0 184 1024 1370" : "0 0 1024 1614"}
    >
      <g id="cardiometabolic-fatmetabolism-diagram+key" clipPath="url(#clip0_18473_208764)">
        <rect width={1024} height={diagramOnly ? 1370 : 1614} fill="white" />
        {showKey && (
          <g id={keyControlsId}>
            <CardiometabolicFatMetabolismKeyContent />
          </g>
        )}
        <g transform={showKey ? `translate(0 60)` : undefined}>
          <CardiometabolicFatMetabolismDiagramContent
            geneColors={geneColors}
            expectedSnps={expectedSnps}
            onGeneClick={onGeneClick}
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_18473_208764">
          <rect width={1024} height={1614} fill="white" />
        </clipPath>
        <clipPath id="clip1_18473_208764">
          <rect width={1024} height={1370} fill="white" transform="translate(0 184)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgCardiometabolicFatMetabolismDiagramKey;
